import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  graphicDesignIcon,
  printMerch,
  uiuxIcon,
} from "../../../../assets/icons/serviceIcon/index";
import BrandingWork from "./BrandingWork";

const items = [
  {
    name: "Logo Design",
    text: "Your logo is more than just a symbol, it’s the face of your brand. We craft logos that don’t just look good but make people remember and trust you.",
  },
  {
    name: "Brand Identity Kit",
    text: "A strong brand needs consistency. We create a complete identity kit including logos, colors, fonts, and templates, so your brand speaks the same powerful language everywhere.",
  },
  {
    name: "Business Collaterals",
    text: "Your brand should leave an impression long after the first interaction. From pitch decks to brochures, we design collaterals that turn prospects into loyal customers.",
  },
];

const otherService = [
  {
    icon: graphicDesignIcon,
    name: "Graphic Design",
    des: " Designs that don’t just look good, but make people stop and stare.",
    path: "/graphic-designing",
  },
  {
    icon: uiuxIcon,
    name: "UI/UX Design",
    des: "Smooth, smart, and seamless experiences your users will love.",
    path: "/ui-ux-designing",
  },
  {
    icon: printMerch,
    name: "Print & Merchandise Design",
    des: "Bring your brand to life with designs people want to own.",
    path: "/print-and-merchandise",
  },
];

const BrandingAndLabel = () => {
  return (
    <div className="">
      <NewCommonServiceHero
        colorHeading="Identity"
        description="Your brand is more than just a logo - it's your story, vibe, and promise. At TechQilla, we bring it all to life. Whether you’re starting fresh or rebranding, we’ll help you create a look and feel that truly reflects who you are and makes people remember you for all the right reasons."
        heading="Branding &"
      />
      <NewCommonServiceForm title="Branding & Identity" items={items} />
      <BrandingWork/>
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default BrandingAndLabel;
